import React from 'react';
import { MdSearch as IconSearch } from 'react-icons/md';
import { withRouter } from 'react-router-dom';
import { Button, Form, FormGroup, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { SizeMe } from 'react-sizeme';

/* Material-ui */
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

/* Tooltip */
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domain, domainIsTenant as dit, S } from '../../routes/routes'

/* Object Json */
import { safeGet, safeGetWithType } from 'iotera-base/json';
import { isNone } from 'iotera-base/object';
import Result from 'iotera-base/result';

import { SubViewHeader } from '../../lib/components/subHeader';
import { RolesTable } from '../../custom/table';
import { setRoleEmpty } from '../../testActions';
import { store } from '../../testStore';
import IoteraClass from '../../lib/components/react/react-class';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';


const INIT_ROLES = 'INIT_ROLES';
const INIT_NAV = "INIT_NAV";
const DELETE = "DELETE"
const WKEY = 'ROLE_LIST';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class RolesCard extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      operation: false,
      search: "",
      filter: false,
      roleList: props.data,
      filters: {
        deviceType: [],
        location: [],
        sensors: [],
        components: [],
        status: []
      },
      custom: window.innerWidth <= 768 ? "col-md-6" : "col-md-5"
    }
    this.resize = this.resize.bind(this);
  }

  resize(event) {
    setTimeout(this.setState({
      custom: window.innerWidth <= 768 ? "col-md-6" : "col-md-5"
    }), 1000)
  }

  handleChange = event => {
    this.setState({ search: event.target.value })
  }

  handleKeyUp = event => {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    if (event.key === "Enter") {
      _this.handleSearchFilter()
    }
    if (((event.key === "Backspace") || (event.key === "Delete")) && _state.search.length === 0) {
      _this.setState({ roleList: _props.data });
    }
  }

  handleSearchFilter = () => {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let newState = Object.assign({}, _state);
    let roles = []
    _props.data.forEach((role) => {
      let foundRole = (_state.search === '') ||
        ((role.name.toLowerCase().search(_state.search.toLowerCase())) !== -1)
      if (foundRole) {
        roles.push(role)
      }
    })
    newState.roleList = roles
    _this.setState({ roleList: roles, filter: true });
    if (_state.search.length === 0) {
      _this.setState({ roleList: _props.data });
    }
  }

  submitHandler(e) {
    e.preventDefault();
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    window.onresize = _this.resize;
    let data = _props.data;
    let navs = _props.navs;
    if (_state.filter) {
      data = _state.roleList
    }
    let length = null
    if (!isNone(data))
      length = data.length;
    const finalData = _props.finalData;
    if (finalData) {
      return (
        <div>
          <Form onSubmit={_this.submitHandler}>
            <FormGroup row>
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <InputGroup>
                  <Input placeholder="Cari berdasarkan nama role" value={_state.search}
                    onChange={_this.handleChange} onKeyUp={_this.handleKeyUp} type="text" step="1" />
                  <InputGroupAddon addonType="append"><Button onClick={_this.handleSearchFilter}>
                    <IconSearch size={16} /></Button></InputGroupAddon>
                </InputGroup>
              </div>
            </FormGroup>
            {length > 0 ?
              <SizeMe>{({ size }) =>
                < div className="table-responsive">
                  <RoleListTableWR data={data} tableSize={size} navs={navs} handleDelete={_props.handleDelete}/>
                </div>
              }</SizeMe>
              :
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Oopss... role tidak ditemukan</div>
              </div>
            }
          </Form>
        </div >
      )
    } else {
      return (
        <div>
          <Form onSubmit={_this.submitHandler}>
            <FormGroup row>
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Oopss... Role Masih Kosong</div>
                <div style={{ textAlign: 'center' }}>Daftar role yang telah dibuat akan ditampilkan disini.</div>
              </div>
            </FormGroup>
          </Form>
        </div>
      )
    }
  }
}

const RoleListTableWR = withRouter(RolesTable);

class Roles extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    }
    this.handleClick = this.handleClick.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete(id) {
    this.props.wSingleRequestCall({
      id: DELETE,
      body: {
        id
      }
    })
  };


  componentWillReceiveProps(nextProps) {
    const _this = this;
    const _props = _this.props
    if (nextProps.location !== _props.location) {
      _this.setState({ prevPath: _props.location })
    }
  }

  handleClick() {
    const _this = this;
    const _props = _this.props
    let navs = _props.navs;
    let emptyFirst = setRoleEmpty();
    store.dispatch(emptyFirst);
    _props.history.push('.' + S + '_role_add_info_')
  };

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const domainIsTenant = dit(_props);
    const domains = domain(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        requests: {
          [INIT_ROLES]: {
            wparam: { ...domainIsTenant, path: "/service/web/application/account/role/list" },
            wcallback: {
              started: function (id) {
                // TODO Loading
              },
              finished: function (id, result) {
                // TODO Loading
              }
            }
          },
          [INIT_NAV]: {
            wparam: { ...domainIsTenant, path: "/service/web/application/nav/list" },
            wcallback: {
              started: function (id) {
                // TODO Loading
              },
              finished: function (id, result) {
                // TODO Loading
                _this.setState({
                  loading: false
                })
              }
            }
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [DELETE]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/account/role/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  _props.history.push('..')
                  _props.history.push('..' + S + domains + S + '_role_list_')
                  _props.showSingleNotification({ message: 'Hapus role berhasil', level: 'success' });
                  return;
                }
              } else {
                const responseResult = safeGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === -21) {
                  _this.setState({
                    loading: false
                  })
                  _props.showSingleNotification({ message: 'Hapus role gagal, masih terikat dengan user', position: 'tr', level: 'error' });
                  return;
                }
                _this.setState({
                  loading: false
                })
                _props.showSingleNotification({ message: 'Hapus role gagal', position: 'tr', level: 'error' });
              }
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let navs = _props.navs;
    let role = { ..._props.items };
    let finalData = false;
    let { loading } = _state;
    let data = role.data
    if (!isNone(data)) {
      if ((data.length > 0)) {
        const editRole = [...data];
        for (let i = 0; i < data.length; i++) {
          const newNavs = [...safeGet(data, [i, 'navs'])];
          for (let j = 0; j < newNavs.length; j++) {
            newNavs[j] = safeGet(navs, [newNavs[j], 'label'])
          }
          editRole[i] = {
            id: data[i].id,
            description: data[i].description,
            name: data[i].name,
            navs: newNavs
          };
        }
        role.data = editRole;
        finalData = true;
      }
    }
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Role' subTitle='Seluruh role yang terdaftar di aplikasi ini.' />
          <div className="view-content-dashboard">
            <RolesCard {..._props} data={role.data} finalData={finalData} navs={navs} handleDelete={_this.handleDelete} />
            <Tooltip TransitionComponent={Zoom} title='Tambah Role' enterDelay={500} >
              <Fab variant="extended" color={'primary'} style={{
                position: 'absolute',
                bottom: 0 * 2,
                right: 20 * 2
              }}
                onClick={(e) => _this.handleClick(e)}
              >
                <AddIcon style={{ marginRight: 8 }} />
                Role Baru
              </Fab>
            </Tooltip>
          </div>
        </div>
      </Loader >
    )
  }
}

const mapStateToProps = function (state) {
  return {
    items:
    {
      data: wSelector.getMappedRPayload(state, INIT_ROLES, 'roles')
    },
    navs: wSelector.getMappedRPayload(state, INIT_NAV, 'navs')
  }
};

const mapDispatchToProps = (dispatch) => ({
  ...wBoundActions(dispatch),
  ...bindActionCreators(notificationActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Roles));
